import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { StoreService } from '../../../services/store/store.service';

@Component({
  selector: 'app-store-create-dialog', templateUrl: './store-create-dialog.component.html', styleUrls: ['./store-create-dialog.component.css'], standalone: true,
  imports: [FormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule],
})
export class StoreCreateDialogComponent {
  readonly dialogRef = inject(MatDialogRef<StoreCreateDialogComponent>);
  private readonly stores = inject(StoreService);
  private readonly cdr = inject(ChangeDetectorRef);
  id: number | null = null;
  place = '';
  district = '';
  address = '';
  signature = '';
  saving = false;
  error = '';
  constructor() { this.dialogRef.disableClose = true; }
  get dirty(): boolean { return this.id !== null || !!this.place || !!this.district || !!this.address || !!this.signature; }
  get isValid(): boolean {
    return this.id !== null && Number.isInteger(Number(this.id)) && Number(this.id) > 0 && !!this.place.trim() && !!this.district.trim() && !!this.signature.trim();
  }
  save(): void {
    if (!this.isValid || this.id === null || this.saving) return;
    this.saving = true; this.error = '';
    this.stores.createStore({ id: Number(this.id), place: this.place.trim(), district: this.district.trim(), address: this.address.trim() || undefined, signature: this.signature.trim() }).subscribe({
      next: () => this.dialogRef.close(true),
      error: (error: HttpErrorResponse) => {
        this.saving = false;
        this.cdr.markForCheck();
        this.error = error.status === 409 ? 'Butiksnummeret findes allerede, også hvis butikken er inaktiv.' : 'Butikken kunne ikke oprettes. Dine oplysninger er bevaret. Prøv igen.';
      },
    });
  }
  cancel(): void {
    if (this.canClose()) this.dialogRef.close();
  }
  canClose(): boolean {
    return !this.saving && (!this.dirty || window.confirm('Du har indtastet butiksoplysninger. Vil du lukke uden at oprette butikken?'));
  }
}
